import React, { type FC } from 'react';

import { GlobalStyles } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { type ThemeProviderProps } from '@mui/material/styles/ThemeProvider';

import { styles } from './styles';

/** Theme provider for MUI that adds the colour palette as CSS custom properties */
const ThemeProvider: FC<ThemeProviderProps> = ({ children, ...themeProviderProps }) => (
  <MuiThemeProvider {...themeProviderProps}>
    <GlobalStyles styles={styles} />
    {children}
  </MuiThemeProvider>
);

export default ThemeProvider;
